import { render, staticRenderFns } from "./KPIModal.vue?vue&type=template&id=1524b771&scoped=true&"
import script from "./KPIModal.vue?vue&type=script&lang=js&"
export * from "./KPIModal.vue?vue&type=script&lang=js&"
import style0 from "./KPIModal.vue?vue&type=style&index=0&id=1524b771&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1524b771",
  null
  
)

export default component.exports